import { render, staticRenderFns } from "./infoPanel.vue?vue&type=template&id=b28b1a26&scoped=true&"
import script from "./infoPanel.vue?vue&type=script&lang=js&"
export * from "./infoPanel.vue?vue&type=script&lang=js&"
import style0 from "./infoPanel.vue?vue&type=style&index=0&id=b28b1a26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28b1a26",
  null
  
)

export default component.exports